<template>
	<div>
		<div class="captcha">
			<input
				v-for="(c, index) in ct"
				:key="index"
				type="tel"
				v-model="ct[index]"
				ref="input"
				:class="index === cIndex && 'now-input'"
				@input="
					e => {
						onInput(e.target.value, index);
					}
				"
				@keydown.delete="
					e => {
						onKeydown(e.target.value, index);
					}
				"
				@focus="onFocus"
				@blur="onBlur"
				:disabled="loading"
			/>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			ct: ["", "", "", "", "", ""],
			loading: false
		};
	},
	props: {
		isCorrectCode: {
			type: Number,
			default: 0
		}
	},
	computed: {
		ctSize() {
			return this.ct.length;
		},
		cIndex() {
			let i = this.ct.findIndex(item => item === "");
			i = (i + this.ctSize) % this.ctSize;
			return i;
		},
		lastCode() {
			return this.ct[this.ctSize - 1];
		}
	},
	watch: {
		cIndex() {
			this.resetCaret();
		},
		lastCode(val) {
			if (val) {
				console.log("this.ctSize", this.ctSize);
				this.$refs.input[this.ctSize - 1].blur();
				this.sendCaptcha();
			}
		},
		isCorrectCode(val) {
			console.log('判断输入的验证码是否正确', val);
			if (val) {
				// 验证码失败
				this.reset();
				this.loading = false;
			}
		}
	},
	mounted() {
		// if (/iPhone/i.test(navigator.userAgent)) {
		// 	this.onFocus();
		// }
		this.resetCaret();
	},
	methods: {
		onInput(val, index) {
			val = val.replace(/[^\d]/g, "");
			this.ct[index] = this.ct[index].replace(/[^\d]/g, "");
			if (index == this.ctSize - 1) {
				this.ct[this.ctSize - 1] = val[0]; // 最后一个码，只允许输入一个字符。
			} else if (val.length > 1) {
				let i = index;
				for (i = index; i < this.ctSize && i - index < val.length; i++) {
					this.ct[i] = val[i];
				}
				this.resetCaret();
			}
		},
		// 重置光标位置。
		resetCaret() {
			this.$refs.input[this.ctSize - 1].focus();
		},
		onFocus() {
			// 监听 focus 事件，将光标重定位到“第一个空白符的位置”。
			let index = this.ct.findIndex(item => item === "");
			index = (index + this.ctSize) % this.ctSize;
			console.log(this.$refs.input);
			this.$refs.input[index].focus();
			// 键盘弹起时 发送事件给父组件 更改短验弹窗高度
			this.$emit("handlePageFocus", index)
		},
		onBlur() {
			// 键盘收起时 发送事件给父组件 更改短验弹窗高度
			let index = this.ct.findIndex(item => item === "");
			this.$emit("handlePageBlur", index)
		},
		onKeydown(val, index) {
			if (val === "") {
				// 删除上一个input里的值，并对其focus。
				if (index > 0) {
					this.ct[index - 1] = "";
					this.$refs.input[index - 1].focus();
				}
			}
		},
		sendCaptcha() {
			// 此时无法操作 input。。
			this.loading = true;
			// 调用后端注册接口
			console.log("123", this.ct.join(""));
			// eslint-disable-next-line
			this.$emit("handleRegister", this.ct.join(""));

			// setTimeout(() => {
			// 	// this.msg = "验证码错误";
			// 	this.loading = false;
			// 	this.$nextTick(() => {
			// 		this.reset();
			// 	});
			// }, 3000);
		},

		reset() {
			// 重置。一般是验证码错误时触发。
			this.ct = this.ct.map(item => "");
			this.resetCaret();
		}
	}
};
</script>

<style scoped>
.captcha {
	display: flex;
	justify-content: center;
	margin-top: 24px;
}
input {
	margin-right: 10px;
	width: 44px;
	height: 44px;
	background: #ffffff;
	border-radius: 2px;
	border: 1px solid #dddddd;
	text-align: center;
	font-size: 24px;
	font-family: DINPro-Medium, DINPro;
	font-weight: 500;
	color: #333333;
	outline: none;
}
input:last-of-type {
	margin-right: 0;
}
input:disabled {
	color: #000;
	background-color: #fff;
}
.now-input {
	border: 1px solid #2e2e33;
}
.msg {
	text-align: center;
}
</style>